export const consentsMarketingsFieldKeysMap = new Map([
    ['thematicPromotional', 'Promotional offers'],
    ['thematicComfort', 'Comfort'],
    ['thematicWeather', 'Weather'],
    ['thematicSecurity', 'Security'],
    ['thematicSustainability', 'Sustainability'],
    ['channelEmail', 'E-mail'],
    ['channelPush', 'Push Notification'],
    ['channelInApp', 'In-App News'],
]);
